import React from 'react';
import UrlLink from '../../../components/UI/UrlLink/UrlLink';
import classes from './HandlingUserData.module.css';
import paths from '../../../constants/paths';

import { QUERY_PARAM_DELETE_ACCOUNT } from '../../../containers/ContactUs/ContactUsContainer';

const de = (props) => (
  <div className={classes.Content}>
    {props.indexPage ? (
      <div>
        <p style={{ marginBottom: props.indexPage ? '1rem' : 0 }}>
          <b>Daten herunterladen</b>
        </p>
        <p>
          Um Ihre Daten herunterzuladen, gehen Sie auf die folgende Seite
          <br />
          Einstellungen {'>'} Optionen {'>'} Datenverwaltung {'>'} Daten
          herunterladen
        </p>
        <br />
        <div className={classes.HrLine} />
        <br />
      </div>
    ) : null}
    <p style={{ textAlign: props.indexPage ? 'left' : 'center' }}>
      <b>Datenlöschung anfordern</b>
    </p>
    <br />
    <p>
      Führen Sie die folgenden Schritte aus, um die Löschung von Daten zu
      beantragen:
    </p>
    <br />
    <p>
      1. Gehen{' '}
      <UrlLink
        to={`${
          props.indexPage ? paths.CONTACT_US : paths.SETTINGS__CONTACT_US
        }?${QUERY_PARAM_DELETE_ACCOUNT}`}
      >
        Sie zur Kontaktseite
      </UrlLink>
      <br />
      2. Wählen Sie die Option "Konto und alle meine Daten löschen" <br />
      3. Füllen Sie das Formular aus und klicken Sie auf „Nachricht senden“.{' '}
      <br />
      <br />
    </p>
  </div>
);

export default de;



// WEBPACK FOOTER //
// ./src/assets/localization/hud/de.js